/* unplugin-vue-components disabled */import script from "./Notification.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Notification.vue?vue&type=script&setup=true&lang=tsx"

import "./Notification.vue?vue&type=style&index=0&id=c338f0b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c338f0b6"]])

export default __exports__